function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.8 19.7c-.3 0-.6.1-.8.3a12 12 0 0 0-4.8 9.5v10c0 .7.6 1.2 1.3 1.2h22.7c.6 0 1.2-.6 1.2-1.2v-10a12 12 0 0 0-4.7-9.5c-.4-.3-1-.3-1.4 0a12.7 12.7 0 0 1-13.5-.3zm7-19.6A9 9 0 0 0 19 9a9 9 0 0 0 8.9 8.9A9 9 0 1 0 27.8 0v.1zm12.3 17.8c-.3 0-.6.1-.8.3l-1 1a1.3 1.3 0 0 0 1.7 1.7l.2-.2c3.4 1.6 7.3 1.6 10.7 0a7 7 0 0 1 2.2 5.1v6.5H42.7c-.7 0-1.3.5-1.3 1.2a1.3 1.3 0 0 0 1.6 1.3h11.4c.7 0 1.2-.6 1.2-1.3v-7.7c0-3-1.4-5.8-3.8-7.6-.4-.3-1-.3-1.4-.1a9.7 9.7 0 0 1-9.7 0l-.6-.2zm5.5-15.2c-4 0-7.2 3.2-7.2 7.2s3.3 7.2 7.2 7.2c4 0 7.2-3.3 7.2-7.2v-.1c0-4-3.3-7.1-7.2-7.1zm-41 15.2c-.3 0-.6.1-.8.3A9.6 9.6 0 0 0 0 25.8v7.7c0 .7.6 1.3 1.3 1.3h11.3a1.3 1.3 0 0 0 1.7-1.3 1.3 1.3 0 0 0-1.7-1.2h-10v-6.5a7 7 0 0 1 2.1-5.1c3.4 1.6 7.3 1.6 10.7 0l.2.2a1.3 1.3 0 1 0 1.9-1.7 10 10 0 0 0-1.2-1c-.4-.3-.9-.3-1.3-.1a9.7 9.7 0 0 1-9.7 0l-.6-.2h-.1zm5.5-15.2c-4 0-7.2 3.2-7.2 7.2s3.3 7.2 7.2 7.2c4 0 7.2-3.3 7.2-7.2v-.1c0-4-3.3-7.1-7.2-7.1H10h.1z",
  fill: "#fff"
});

var SvgIconWorkers = function SvgIconWorkers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 56 41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.4,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconWorkers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_workers.2518ba1c.svg";
export { ForwardRef as ReactComponent };